import { IApplicationState } from '../../types/redux';

export function selectAdditionalServices(state: IApplicationState) {
  return state.promoInfo.additionalServices;
}
